import { useEffect, useState } from "react";
import axios from 'axios';

const Engagements = () => {

    const [engagements, setEngagements] = useState<any[]>([]);
    const [engagement, setEngagement] = useState<any | null>({ id: -1 });

    // const projectsUrl = "http://delfin.tortugadesign.com/Projects";
    // const projectUrl = "http://delfin.tortugadesign.com/Projects/GetById?id=";

    // const projectsUrl = "https://localhost:7020/Projects";
    // const projectUrl = "https://localhost:7020/Projects/GetById?id=";

    const projectsUrl = "http://delfintech-001-site7.qtempurl.com/projects";
    const projectUrl = "http://delfintech-001-site7.qtempurl.com/projects/GetById?id=";

    useEffect(() => {
        fetchProjects();
    }, []);

    useEffect(() => {
        engagement && engagement.id !== -1 && fetchProject();
    }, [engagement.id])

    const fetchProjects = async () => {
        // Make a request
        axios.get(projectsUrl)
            .then(function (response) {
                // handle success
                setEngagements(response.data);
            })
            .catch(function (error) {
                // handle error
                console.log(error);
            })
            .finally(function () {
                // always executed
            });
    }

    const fetchProject = async () => {
        // Make a request
        axios.get(projectUrl + engagement.id)
            .then(function (response) {
                // handle success
                const projMarkup = response.data;
                setEngagement(projMarkup);
            })
            .catch(function (error) {
                // handle error
                console.log(error);
            })
            .finally(function () {
                // always executed
            });
    }

    const projList = () => {
        return engagements.map((el) => {
            const imgUrl = `../assets/img/${el.symbol}`;;
            const imgTitle = `${el.name} - ${el.project}`;
           
            return <li key={el.id} onClick={() => setEngagement(el)} title={imgTitle}>

                <span className="engagement-link"> <img alt={el.symbol} src={imgUrl} height="55" />
                    {el.name}
                </span>


                {/* if the current one is found */}
                {engagement?.id === el.id && (
                    <div className="engagement">
                        <h1>{el.project}
                            <img className="engagement-icon" alt={el.symbol} src={imgUrl} height="25" /></h1>
                            {createMarkup(engagement.description)}
                            {engagement.url && <><br/><br/><a target="_blank" href={engagement.url}>[Check out more...]</a></>}
                    </div>
                )}

            </li>;
        });
    }

    const createMarkup = (stringText: string) => {
        const markup = { __html: stringText };
        return <div dangerouslySetInnerHTML={markup} />;
    }

    return (<>
        <div className="engagement-header">
            <h2>
                20+ years of successful engagements!
            </h2>
            <h3><i>Brands we have worked on...</i></h3>

        </div>
        <div className="engagement-body">
            <ul>
                {projList()}
            </ul>
        </div>
    </>
    )
}
export default Engagements;